import iWhiteRhombus from "../../../assets/icons/white-rhombus.svg";
import iWhitePolygon from "../../../assets/icons/white-polygon.svg";
import { useWidth } from "../../../hooks/use-width";
import { formatNumber } from "../../../utils";
import "./cases-highlight-item.sass";

type Props = {
  value: number | string;
  text: string;
  color: string;
  width: string;
  index: number;
};

const CasesHighlightItem = ({ color, text, value, width, index }: Props) => {
  const { isDesktopWidth } = useWidth();

  return (
    <div
      className="cases-highlight-item"
      style={{
        backgroundColor: color,
        width: isDesktopWidth ? width : "100%",
      }}
    >
      <div className="cases-highlight-item__upper">
        <img
          src={index === 0 ? iWhitePolygon : iWhiteRhombus}
          className="cases-highlight-item__polygon"
          alt=""
        />
      </div>
      <div className="cases-highlight-item__bottom">
        <div className="cases-highlight-item__value">{formatNumber(value)}</div>
        <div className="cases-highlight-item__text">{text}</div>
      </div>
    </div>
  );
};

export default CasesHighlightItem;
